<template>
  <div id="app" class="container-fluid p-0">

    <app-header></app-header>

    <div
      v-if="isIntroPage"
      class="app__intro-title"
    >
      <intro-title
        :page="db.pages[$route.params.id]"
        :key="$route.fullPath"
      />
    </div>

    <div
      v-else
      class="app__indicator-title"
    >
      <indicator-title
        :page="db.pages[$route.params.id]"
        :key="$route.fullPath"
      />
    </div>

    <div class="app__body container-fluid p-0">

      <div class="page-wrapper">

        <transition
          name="shift"
          mode="out-in"
        >
          <router-view :page="db.pages[$route.params.id]"
                       :key="$route.fullPath"
          />
        </transition>

      </div>

      <div class="ir-nav-wrapper">
        <nav class="ir-nav">
          <b-link
            class="nav-btn nav-btn--prev"
            title="Previous page"
            :disabled="previousBtnDisabled"
            :to="previous()"
          >
            <font-awesome-icon icon="chevron-up" size="2x"/>
          </b-link>
          <b-link
            class="nav-btn nav-btn--next"
            title="Next page"
            :disabled="nextBtnDisabled"
            :to="next()"
          >
            <font-awesome-icon icon="chevron-down"  size="2x" />
          </b-link>
        </nav>
      </div>

    </div>

    <app-footer></app-footer>

    <cookie-law ref="cookieBanner"
      theme="eti"
      v-on:accept="acceptCookies()"
    ></cookie-law>

  </div>
</template>

<script>
  import AppFooter from './components/AppFooter/AppFooter'
  import AppHeader from './components/AppHeader/AppHeader'
  import CookieLaw from 'vue-cookie-law'
  import Database from './db.json'
  import IndicatorTitle from './components/IndicatorTitle/IndicatorTitle'
  import IntroTitle from '@/components/IntroTitle/IntroTitle'

  export default {
    name: 'App',
    components: {
      AppFooter,
      AppHeader,
      CookieLaw,
      IndicatorTitle,
      IntroTitle
    },
    mounted() {
      this.$store.commit('setGlobalData', this.db.global)
    },
    data() {
      return {
        db: Database
      }
    },
    methods: {
      next() {
        return this.pathToPage(Number(this.$route.params.id) + 1)
      },
      pathToPage(index) {
        return "/" + index
      },
      previous() {
        return this.pathToPage(Number(this.$route.params.id) - 1)
      },
      acceptCookies() {
        // Enable GA tracking
        // Credit: https://github.com/MatteoGabriele/vue-gtag/issues/115#issuecomment-624591398
        window['ga-disable-UA-9225247-4'] = false
      },
    },
    computed: {
      isIntroPage() {
        if (this.$route.params.id === "0") {
          return true
        } else {
          return false
        }
      },
      nextBtnDisabled() {
        return Number(this.$route.params.id) + 1 === Number(this.db.pages.length)
      },
      previousBtnDisabled() {
        return Number(this.$route.params.id) <= 0
      }
    }
  }
</script>

<style src="./App.scss" lang="scss"></style>
